export default __webpack_public_path__ + "90246781303b9ce05f96ac365062b257.svg";